import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_PETITION_SIGNER_REENGAGEMENT_RECOMMENDATIONS_ENABLED = defineFcm(
	'comms_stack_petition_signer_reengagement_recommendations_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'comms stack',
		description:
			'Enables collation service recommendations lookup for petition_signer_reengagement message in comms stack.',
		import: false,
	});
